"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardSenderImageOption')(function discardSenderImageOption(state) {
    var optionState = state.optionState;
    optionState.showSenderImageInListView = null;
}));
//# sourceMappingURL=discardSenderImageOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-image-option/lib/actions/discardSenderImageOption.js
// module id = 5102
// module chunks = 2